import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { realtorSearchConstants, realtorSearchModels } from '..';

export const useFlatIdRealtor = (props: { id?: string } = {}) =>
  useQuery<realtorSearchModels.IFlatRealtor>({
    queryKey: [realtorSearchConstants.queryKeys.FLAT_ID_REALTOR, props],
    queryFn: async () => {
      const res = await $api.get(`/v1/flat/${props?.id}/realtor`);

      return res.data.data;
    }
  });
